<template>
  <DialogLayout
    title="詳細情報"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <FeesForStopMasterForm
        ref="feesForStopMasterForm"
        v-model="feesForStopMasterFormModel"
        label-width="10em"
        formMode="edit"
        :editDisabledMode="editDisabledMode"
        tableType="STOP"
      />
    </template>
    <template v-if='!editDisabledMode' #footer>
      <EditDialogFooter
        @update="clickUpdate"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FeesForStopMasterForm from '@/components/organisms/dialog/feeMaster/FeesForStopMasterForm.vue'
import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    FeesForStopMasterForm,
    EditDialogFooter
  },
  props: {
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      feesForStopMasterFormModel: {
        charge_year: undefined,
        route_code: undefined,
        row_number: undefined,
        min_weight: undefined,
        max_weight: undefined,
        detail_update_flag: false,
        details: [{ data_range_from: undefined, data_range_to: undefined, charge: undefined, flat_charge_flag: undefined }],
        updated_on: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    },
    editDisabledMode: {
      get () {
        return this.feesForStopMasterFormModel.regist_type === '1' || parseInt(this.feesForStopMasterFormModel.billing_ym) < parseInt(this.getDefaultBillingYm())
      }
    }
  },
  mounted () {
  },
  methods: {
    async clickUpdate () {
      this.$loadingMask.on()
      this.$refs.feesForStopMasterForm.validate()
        .then((valid) => {
          return this.$axios.put('/fees-for-stop-master', this.feesForStopMasterFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.$emit('refresh', this.feesForStopMasterFormModel.charge_year)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
          this.$loadingMask.off()
        })
    },
    open () {
      // const trimItem = ['registration_symbol', 'bill_to_code', 'action_type']
      this.$nextTick(() => {
        this.$refs.feesForStopMasterForm.clearFields()
        Object.keys(this.feesForStopMasterFormModel)
          .forEach((x) => {
            // if (trimItem.includes(x)) {
            //   this.currentRow[x] = this.currentRow[x].trimEnd()
            // }
            this.$set(this.feesForStopMasterFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
